import * as React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/add_parent_task_wizard/AddParentTaskForm.scss';
import Button from '../../components/Button';
import { __, mapStateToProps, setTableParams } from '../../core/utils';
import { withRouter } from 'react-router';
import { listPossibleSubstagesWithChildren } from '../../redux/actions/table/all_tasks';
import * as _ from 'lodash';
import SearchableDropdown from '../../components/SearchableDropdown';
import Tooltip from '../../components/Tooltip';
import classNames from 'classnames';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';

const AddParentTaskForm = (props) => {
  const [possible_substages_with_children, setPossibleSubstagesWithChildren] =
    useState([]);
  const [selected, setSelected] = useState({
    values: [],
    type: null,
    substage_id: null,
    task_id: null,
  });

  useEffect(() => {
    listPossibleSubstagesWithChildren(props.store.add_parent_task_wizard).then(
      ({ response }) => {
        setPossibleSubstagesWithChildren(response.data || []);
      },
    );
  }, [props.store.add_parent_task_wizard]);

  const normalizedSubstagesWithChildren = useMemo(
    () =>
      _.map(possible_substages_with_children, (option, index) => ({
        ...option,
        group_option_key:
          option?.group_option_key || `__group__${option?.group_id}`,
        option_key:
          option?.option_key ||
          ['be', option?.group_id, option?.value, option?.label, index].join(
            '_',
          ),
      })),
    [possible_substages_with_children],
  );

  const dropdownOptions = normalizedSubstagesWithChildren;

  const selectedTaskOption = _.find(dropdownOptions, {
    value: selected.task_id,
  });
  const selectedGroupOption = _.find(dropdownOptions, {
    group_id: selected.substage_id,
  });
  const selectedLabel =
    selected.type === 'group'
      ? _.get(selectedGroupOption, 'group')
      : _.get(selectedTaskOption, 'label');

  return (
    <Form onSubmit={props.handleSubmit} className={styles.wrapper}>
      <div className={styles.form}>
        <SearchableDropdown
          options={dropdownOptions}
          dropdownContentClassName={styles.dropdownContent}
          multiselect
          closable={false}
          top={30}
          header={
            <div className={styles.dropdownHeader}>
              <Tooltip
                text={__('add-parent-task-form.group-and-substage')}
                className={styles.filterHeaderName}
              >
                {__('add-parent-task-form.group-and-substage')}
              </Tooltip>

              <span
                className={styles.filterHeaderClearAll}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelected({
                    values: [],
                    type: null,
                    substage_id: null,
                    task_id: null,
                  });
                  props.change('task_group_id', null);
                  props.change('selection_level', null);
                }}
              >
                {__('add-parent-task-form.group-and-substage.clear')}
              </span>
            </div>
          }
          selectedValues={selected.values}
          name={'test'}
          leftStyled
          onSelect={(item, groupLabel) => {
            if (item.groupHeading) {
              const groupValues = _.map(
                _.filter(dropdownOptions, (option) =>
                  item.group_id
                    ? option.group_id === item.group_id
                    : option.group === groupLabel,
                ),
                'option_key',
              );

              setSelected({
                values: [item.group_option_key, ...groupValues],
                type: 'group',
                substage_id: item.group_id || null,
                task_id: null,
              });
              props.change('task_group_id', item.group_id || null);
              props.change('selection_level', 'substage');
              return;
            }

            setSelected({
              values: [item.option_key || item.value],
              type: 'child',
              substage_id: null,
              task_id: item.value,
            });
            props.change('task_group_id', item.value || null);
            props.change('selection_level', 'group');
          }}
          onRemove={() => {
            setSelected({
              values: [],
              type: null,
              substage_id: null,
              task_id: null,
            });
            props.change('task_group_id', null);
            props.change('selection_level', null);
          }}
        >
          <div className={styles.bubble}>
            <label className={styles.bubbleLabel}>
              {__('dd-parent-task-form.group-and-substage')}
            </label>
            <span
              className={classNames(!selectedLabel && styles.bubblePlaceholder)}
            >
              {selectedLabel ||
                __('add-parent-task-form.choose-group-and-substage')}
            </span>
            <ArrowDownSmallIcon className={styles.bubbleArrow} />
          </div>
        </SearchableDropdown>
      </div>
      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={() =>
            setTableParams('all_tasks', {
              add_parent_task_wizard: undefined,
            })
          }
        />
        <Button
          lightBlue
          medium
          right
          submit
          middleText={__('button.add')}
          spinning={props.submitting}
        />
      </div>
    </Form>
  );
};

export default withRouter(
  reduxForm({ form: 'add_parent_task_wizard.add_parent_task' })(
    mapStateToProps((state) => ({
      store: state.table.all_tasks,
    }))(AddParentTaskForm),
  ),
);
